"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaPassengerRoomSelectionStepper = _interopRequireDefault(require("./AaPassengerRoomSelection-Stepper.component"));

var _AaButton = _interopRequireDefault(require("../airasia-button-component/AaButton.component"));

var _AaPassengerRoomSelection = require("./AaPassengerRoomSelection.model");

var _AaModalContainer = _interopRequireDefault(require("../airasia-modal-component/AaModalContainer"));

var _AaIcon = _interopRequireDefault(require("../airasia-icon-component/AaIcon.component"));

var _AaIconTypes = _interopRequireDefault(require("../airasia-icon-component/AaIconTypes"));

var _this = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RoomSelectionLabel = function RoomSelectionLabel(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.selectRoomMessage
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_AaIcon["default"], {
    controls: {
      iconName: _AaIconTypes["default"].WARNING_ICON,
      iconStyle: {
        height: 16,
        width: 16,
        color: "#C94318",
        marginLeft: 0,
        marginRight: 6
      }
    }
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.selectRoomMessageInner
  }, props.translation.moreRoomsWarningLabel)));
};

var RoomAddLink = function RoomAddLink(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flex: 1,
      flexDirection: "row"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
    accessibilityRole: "button",
    style: {
      flex: 1
    },
    onPress: props.callback.bind(_this, true)
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: [styles.stepperButtonText, {
      color: '#4b4fa6',
      top: -2,
      marginRight: 4
    }]
  }, "+")), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.addRoomLink
  }, props.translation.addMoreRoomsLabel)))));
};

var AaPassengerSelectionPopup = function AaPassengerSelectionPopup(props) {
  var _useState = (0, _react.useState)(props.data),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      paxCount = _useState2[0],
      setPaxCount = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isMessageVisible = _useState4[0],
      setMessageVisible = _useState4[1];

  var passengerSelectionID = 'aa-passenger-selection';
  (0, _react.useEffect)(function () {
    setPaxCount(props.data);
  });

  var onDonePress = function onDonePress() {
    props.controls.onBackdropClose(false);
  };
  /**
   * 
   * @param {string} key - passenger type (adult, child, infant)
   * @param {string} type - inc or dec
   * 
   * Tells whether to add or subtract a passenger based on `type`
   */


  var changePaxCount = function changePaxCount(key, type) {
    setPaxCount(_objectSpread(_objectSpread({}, paxCount), {}, (0, _defineProperty2["default"])({}, key, type === 'inc' ? paxCount[key]++ : paxCount[key]--)));
    props.controls.onChangeData(paxCount);
  };

  var selectionStepperConfig = {
    controls: {
      stepperClicked: changePaxCount,
      description: {
        adult: {
          label: props.translation.adultLabel,
          sublabel: props.translation.adultDescLabel
        },
        child: {
          label: props.translation.childLabel,
          sublabel: props.translation.childDescLabel
        },
        infant: {
          label: props.translation.infantLabel,
          sublabel: props.translation.infantDescLabel
        },
        youngAdult: {
          label: props.translation.youngAdultLabel,
          sublabel: props.translation.youngAdultDescLabel
        }
      },
      max: props.controls.max,
      min: props.controls.min
    }
  };
  /**
   * Configuration Object for `Done` button
   */

  var aaButtonConfig = {
    controls: {
      onButtonPress: onDonePress,
      customStyle: {
        container: {
          paddingVertical: 10
        }
      }
    },
    data: {
      text: props.translation.paxDoneLabel
    }
  };
  /**
   * 
   * @param {string} type - passenger type(adult, child, infant)
   * 
   * Checks the minimum passenger count based on `type`
   * 
   * Making sure that adult count is always greater than or equal to the infant count
   */

  var getMinPassengerCount = function getMinPassengerCount(type) {
    if (type === _AaPassengerRoomSelection.PASSENGER_TYPE.ADULT || type == _AaPassengerRoomSelection.PASSENGER_TYPE.YOUNGADULT) {
      var diff = paxCount[type === _AaPassengerRoomSelection.PASSENGER_TYPE.ADULT ? "youngAdult" : "adult"] - paxCount.infant;

      if (paxCount.infant === 0 || diff >= 0) {
        return type === _AaPassengerRoomSelection.PASSENGER_TYPE.ADULT ? 1 : props.controls.min;
      } else if (diff < 0) {
        return diff * -1;
      }
    } else {
      return props.controls.min;
    }
  };

  var getTotalPassengerCount = function getTotalPassengerCount() {
    var sum = 0;

    for (var key in paxCount) {
      sum += paxCount[key];
    }

    return sum;
  };
  /**
   * 
   * @param {string} type - passenger type (adult, child, infant)
   * 
   * Controls the maximum passenger count based on `type`
   */


  var getMaxPassengerCount = function getMaxPassengerCount(type) {
    switch (type) {
      case _AaPassengerRoomSelection.PASSENGER_TYPE.ADULT:
        return props.controls.max - paxCount.child - paxCount.infant - paxCount.youngAdult;

      case _AaPassengerRoomSelection.PASSENGER_TYPE.CHILD:
        return props.controls.max - paxCount.adult - paxCount.infant - paxCount.youngAdult;

      case _AaPassengerRoomSelection.PASSENGER_TYPE.YOUNGADULT:
        return props.controls.max - paxCount.adult - paxCount.infant - paxCount.child;

      default:
        var adultCount = paxCount.adult + paxCount.youngAdult;
        return getTotalPassengerCount() === props.controls.max ? paxCount.infant : Math.min(adultCount, props.controls.max - adultCount);
    }
  };
  /**
   * EventListeners that only be triggered when Platform is web and not mobile
   * 
   * This is used for accessibility
   */


  if (!props.controls.isMobilePlatform && _reactNativeWeb.Platform.OS === 'web') {
    var onFocusListener = function onFocusListener() {
      document.addEventListener('keyup', keyUpHandler, false);
    };

    var keyUpHandler = function keyUpHandler() {
      var element = document.getElementById(passengerSelectionID);

      if (!element) {
        return;
      }

      var isChild = element.contains(document.activeElement);

      if (!isChild) {
        onDonePress();
      }
    };

    var handleClickOutside = function handleClickOutside(e) {
      var element = document.getElementById(passengerSelectionID);

      if (!element) {
        return;
      }

      if (e.target !== element && !element.contains(e.target)) {
        onDonePress();
        return;
      }
    };

    (0, _react.useEffect)(function () {
      onFocusListener(); // Bind the event listener

      document.addEventListener("mousedown", handleClickOutside, false);
      return function () {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside, false);
        document.removeEventListener("keyup", keyUpHandler, false);
      };
    }, []);
  }
  /**
   * Layout for passenger selection mobile view
   */


  if (props.controls.isMobilePlatform || !props.controls.isMobilePlatform && props.controls.isMobileLayout) {
    return /*#__PURE__*/_react["default"].createElement(_AaModalContainer["default"], {
      isVisible: props.controls.openModal,
      wrapperStyle: styles.modalPopupContainer,
      backdropColor: "black",
      backdropOpacity: "0.5",
      isClosingOnBackdropPress: true,
      onClose: onDonePress
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.modalPopup
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
      style: styles.roomLabel
    }, props.translation.roomLabel && props.translation.roomLabel.replace("{0}", 1)), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.line
    }), /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionStepper["default"], {
      controls: _objectSpread(_objectSpread({}, selectionStepperConfig.controls), {}, {
        type: _AaPassengerRoomSelection.PASSENGER_TYPE.ADULT,
        min: getMinPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.ADULT),
        max: getMaxPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.ADULT),
        accessibilityProps: {
          addButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxAdultAdd
          },
          removeButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxAdultRemove
          }
        }
      }),
      data: paxCount.adult
    }), /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionStepper["default"], {
      controls: _objectSpread(_objectSpread({}, selectionStepperConfig.controls), {}, {
        type: _AaPassengerRoomSelection.PASSENGER_TYPE.YOUNGADULT,
        min: getMinPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.YOUNGADULT),
        max: getMaxPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.YOUNGADULT),
        accessibilityProps: {
          addButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxYoungAdultAdd
          },
          removeButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxYoungAdultRemove
          }
        }
      }),
      data: paxCount.youngAdult
    }), /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionStepper["default"], {
      controls: _objectSpread(_objectSpread({}, selectionStepperConfig.controls), {}, {
        type: _AaPassengerRoomSelection.PASSENGER_TYPE.CHILD,
        min: getMinPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.CHILD),
        max: getMaxPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.CHILD),
        accessibilityProps: {
          addButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxChildAdd
          },
          removeButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxChildRemove
          }
        }
      }),
      data: paxCount.child
    }), /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionStepper["default"], {
      controls: _objectSpread(_objectSpread({}, selectionStepperConfig.controls), {}, {
        type: _AaPassengerRoomSelection.PASSENGER_TYPE.INFANT,
        min: getMinPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.INFANT),
        max: getMaxPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.INFANT),
        accessibilityProps: {
          addButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxInfantAdd
          },
          removeButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxInfantRemove
          }
        }
      }),
      data: paxCount.infant
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.line
    }), isMessageVisible && /*#__PURE__*/_react["default"].createElement(RoomSelectionLabel, {
      translation: props.translation
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.container
    }, /*#__PURE__*/_react["default"].createElement(RoomAddLink, {
      callback: function callback() {
        return setMessageVisible(true);
      },
      translation: props.translation
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.button
    }, /*#__PURE__*/_react["default"].createElement(_AaButton["default"], {
      controls: aaButtonConfig.controls,
      data: aaButtonConfig.data
    })))));
  } else {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.popupContainer
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.popup,
      nativeID: passengerSelectionID
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
      style: styles.roomLabel
    }, props.translation.roomLabel && props.translation.roomLabel.replace("{0}", "1")), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.line
    }), /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionStepper["default"], {
      controls: _objectSpread(_objectSpread({}, selectionStepperConfig.controls), {}, {
        type: _AaPassengerRoomSelection.PASSENGER_TYPE.ADULT,
        min: getMinPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.ADULT),
        max: getMaxPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.ADULT),
        accessibilityProps: {
          addButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxAdultAdd
          },
          removeButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxAdultRemove
          }
        }
      }),
      data: paxCount.adult
    }), /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionStepper["default"], {
      controls: _objectSpread(_objectSpread({}, selectionStepperConfig.controls), {}, {
        type: _AaPassengerRoomSelection.PASSENGER_TYPE.YOUNGADULT,
        min: getMinPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.YOUNGADULT),
        max: getMaxPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.YOUNGADULT),
        accessibilityProps: {
          addButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxYoungAdultAdd
          },
          removeButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxYoungAdultRemove
          }
        }
      }),
      data: paxCount.youngAdult
    }), /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionStepper["default"], {
      controls: _objectSpread(_objectSpread({}, selectionStepperConfig.controls), {}, {
        type: _AaPassengerRoomSelection.PASSENGER_TYPE.CHILD,
        min: getMinPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.CHILD),
        max: getMaxPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.CHILD),
        accessibilityProps: {
          addButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxChildAdd
          },
          removeButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxChildRemove
          }
        }
      }),
      data: paxCount.child
    }), /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionStepper["default"], {
      controls: _objectSpread(_objectSpread({}, selectionStepperConfig.controls), {}, {
        type: _AaPassengerRoomSelection.PASSENGER_TYPE.INFANT,
        min: getMinPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.INFANT),
        max: getMaxPassengerCount(_AaPassengerRoomSelection.PASSENGER_TYPE.INFANT),
        accessibilityProps: {
          addButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxInfantAdd
          },
          removeButtonProps: {
            accessibilityLabel: props.translation.accessibility && props.translation.accessibility.paxInfantRemove
          }
        }
      }),
      data: paxCount.infant
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.line
    }), isMessageVisible && /*#__PURE__*/_react["default"].createElement(RoomSelectionLabel, {
      translation: props.translation
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.container
    }, /*#__PURE__*/_react["default"].createElement(RoomAddLink, {
      callback: function callback() {
        return setMessageVisible(true);
      },
      translation: props.translation
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.button
    }, /*#__PURE__*/_react["default"].createElement(_AaButton["default"], {
      controls: aaButtonConfig.controls,
      data: aaButtonConfig.data
    })))));
  }
};

var styles = _StyleSheet["default"].create({
  container: {
    flex: 1,
    flexDirection: "row",
    marginBottom: 15
  },
  modalPopupContainer: {
    flex: 1,
    flexDirection: 'row-reverse',
    web: {
      flexDirection: 'column-reverse'
    },
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.7)',
    height: 0,
    ios: {
      height: '100%',
      alignItems: 'flex-end'
    },
    android: {
      height: '100%',
      alignItems: 'flex-end'
    },
    bottom: 0
  },
  popupContainer: {
    flex: 1
  },
  overlay: {
    web: {
      position: 'fixed',
      overflowY: 'auto'
    },
    width: '100%',
    height: '100%',
    top: 0,
    zIndex: 0,
    flex: 1
  },
  modalPopup: {
    backgroundColor: "white",
    borderColor: "#bfc5cf",
    borderWidth: 1,
    padding: 24,
    width: '100%',
    position: "absolute",
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5
  },
  popup: {
    backgroundColor: "white",
    borderColor: "#bfc5cf",
    borderWidth: 1,
    padding: 20,
    borderRadius: 4,
    width: 280,
    position: "absolute",
    top: 5,
    left: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84
  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: "#d9dbe0",
    marginVertical: 10
  },
  buttonContainer: {
    flexDirection: "row",
    //justifyContent: "flex-end",
    marginVertical: 10,
    web: {
      minHeight: 40
    }
  },
  button: {
    width: 120,
    justifyContent: "flex-end",
    web: {
      marginVertical: 0
    }
  },
  selectRoomMessage: {
    backgroundColor: "rgba(201, 67, 24, 0.1)",
    borderColor: "#B73810",
    borderWidth: 1,
    borderRadius: 4,
    marginTop: 2,
    marginBottom: 12,
    paddingVertical: 12,
    paddingHorizontal: 12,
    flex: 1,
    flexDirection: "row"
  },
  selectRoomMessageInner: {
    color: "#C94318",
    fontSize: 12,
    lineHeight: 16
  },
  roomLabel: {
    color: "#212124",
    lineHeight: 22,
    fontSize: 16
  },
  addRoomLink: {
    color: "#4B4FA6",
    lineHeight: 20,
    fontSize: 16,
    fontWeight: '500'
  },
  stepperButtonText: {
    fontSize: 20,
    color: '#4b4fa6',
    textAlign: 'center',
    position: 'relative'
  }
});

var _default = AaPassengerSelectionPopup;
exports["default"] = _default;